import { Component, Input, OnInit, Output, EventEmitter, SimpleChanges, OnDestroy, inject } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { WorkTaskService } from 'src/app/services/work-task.service';
import { TaskGruopModel } from 'src/app/models/task-group.model';
import { JobModel } from 'src/app/models/job.model';
import { Guid } from 'guid-typescript';
import { SupplierService } from 'src/app/services/supplier.services';
import { ImageService } from 'src/app/shared/services/image.service';
import { SupplierModel } from 'src/app/models/supplier.model';
import { ClientModel } from 'src/app/models/client.model';
import { DatePipe, NgClass } from '@angular/common';
import { UserService } from 'src/app/shared/services/user.service';
import { ProductService } from 'src/app/services/product.service';
import { ProductModel } from 'src/app/models/products';
import { WorkTaskModel } from 'src/app/models/worktask.model';
import { workTaskRules } from 'src/assets/data/task_job_default_rules.config';
import { ContractorSearchModel } from 'src/app/models/contractor-search.model';
import { WorkloadCoordinatesModel } from 'src/app/models/workload-coordinates.model';
import { ColorsModel } from 'src/app/models/colors.model';
import { ProductQualityModel } from 'src/app/models/product-quality.model';
import { ToastService } from 'src/app/services/toast.service';
import { VisitModel } from 'src/app/models/visit.model';
import { catchError, debounceTime, distinctUntilChanged, filter, lastValueFrom, map, merge, of, Subscription } from 'rxjs';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { MatFormField, MatLabel, MatInput, MatSuffix } from '@angular/material/input';
import { MatSelect, MatOption } from '@angular/material/select';
import { MatIcon } from '@angular/material/icon';
import { MatDatepickerInput, MatDatepickerToggle, MatDatepicker } from '@angular/material/datepicker';
import { NgxMaterialTimepickerModule, NgxMaterialTimepickerTheme } from 'ngx-material-timepicker';
import { MatSelectionList, MatListOption } from '@angular/material/list';
import { MatCard, MatCardTitle, MatCardContent } from '@angular/material/card';
import { FilterByNamePipe } from '../../../shared/pipes/filter-by-name.pipe';

/** Id of the site visit task group ("Visita" rule in task_job_default_rules.config). */
const SITE_VISIT_GROUP_ID = workTaskRules.find((rule) => rule.taskName === 'Visita')?.taskId;

const normalize = (text: string | undefined) =>
  (text ?? '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim().toLowerCase();

/**
 * Task group a CRM opportunity is managed with. Matched by its stable id first; by name as a fallback, since the
 * group is named "Visita" in some environments and "Visita de Terreno" in others.
 */
export function findSiteVisitGroup(groups: TaskGruopModel[]): TaskGruopModel | undefined {
  return (
    groups.find((group) => group.id?.toString() === SITE_VISIT_GROUP_ID) ??
    groups.find((group) => normalize(group.description).startsWith('visita'))
  );
}

@Component({
  selector: 'app-work-task',
  templateUrl: './work-task.component.html',
  styleUrls: ['./work-task.component.scss'],
  imports: [FormsModule, ReactiveFormsModule, NgClass, MatSlideToggle, MatFormField, MatLabel, MatSelect, MatOption, MatIcon, MatInput, MatDatepickerInput, MatDatepickerToggle, MatSuffix, MatDatepicker, NgxMaterialTimepickerModule, MatSelectionList, MatListOption, MatCard, MatCardTitle, MatCardContent, DatePipe, FilterByNamePipe]
})
export class WorkTaskComponent implements OnInit, OnDestroy {
  private readonly workTaskSvc = inject(WorkTaskService);
  private readonly supplierSvc = inject(SupplierService);
  imageSvc = inject(ImageService);
  datepipe = inject(DatePipe);
  private readonly productSvc = inject(ProductService);
  toastr = inject(ToastService);
  userSvc = inject(UserService);

  @Input() form: UntypedFormGroup = new UntypedFormGroup({});
  @Input() coordinates: WorkloadCoordinatesModel = {};
  @Input() fromCMR: boolean = false;
  @Output() disableSubmit = new EventEmitter();

  private readonly subs: Subscription = new Subscription();

  client: ClientModel | undefined;
  hasWorkTaskRules: boolean = false;
  TERRAIN_VISIT_ID: string | undefined = '1af64f64-5717-4562-b3fc-2c963f66cda1';
  selectedJobId: string = '00000000-0000-0000-0000-000000000000';

  selected: Date | null | undefined;

  selectedTaskGroup!: TaskGruopModel | undefined; selectedJob: JobModel | undefined;
  /** "Agregar" was pressed without a subcategory: the field is marked until one is chosen. */
  jobMissing = false;
  taskGroups: TaskGruopModel[] = []; // tipo de tarea
  jobs: JobModel[] = []; // Subcategoria
  jobsList: WorkTaskModel[] = [];
  supplierList: SupplierModel[] = [];
  searchText!: string;
  selectedContractor: string | undefined;
  minDate = new Date();
  minHour: any = '00:00';
  // Clock dialog colours aligned with the app tokens (--tp-color-primary / --tp-color-primary-soft / --tp-color-text).
  clockTheme: NgxMaterialTimepickerTheme = {
    container: {
      bodyBackgroundColor: '#ffffff',
      buttonColor: '#296ba1',
      primaryFontFamily: 'inherit',
    },
    dial: {
      dialBackgroundColor: '#296ba1',
      dialActiveColor: '#ffffff',
      dialInactiveColor: 'rgba(255, 255, 255, 0.6)',
      dialEditableActiveColor: '#ffffff',
      dialEditableBackgroundColor: '#1f5a8a',
    },
    clockFace: {
      clockFaceBackgroundColor: '#e8f0f7',
      clockHandColor: '#296ba1',
      clockFaceTimeInactiveColor: '#1b1d21',
      clockFaceInnerTimeInactiveColor: '#6b7280',
      clockFaceTimeActiveColor: '#ffffff',
      clockFaceTimeDisabledColor: '#c5cad1',
    },
  };
  geolocationService: any;
  products: ProductModel[] = [];
  productsQualityList: ProductQualityModel[] = [];
  visitsList: VisitModel[] = [];
  showVisits: boolean = false;

  colorList: ColorsModel[] = [];
  showProductProps: boolean = false;
  showRevetmentProps: boolean = false;
  showRevetmentPropsByDefault: boolean = false;
  showProimotionaldiscount: boolean = false;
  promDiscount: number = 0;
  selectedProduct!: ProductModel;
  timeSelected: boolean = false;

  workTaskForm = new UntypedFormGroup({
    task: new UntypedFormControl(Guid.createEmpty().toString()),
    description: new UntypedFormControl(''),
    contractor: new UntypedFormControl(null),
    taskGroup: new UntypedFormControl('', Validators.required),
    product: new UntypedFormControl(null, Validators.required),
    productColor: new UntypedFormControl(null),
    productQuality: new UntypedFormControl(null),
    date: new UntypedFormControl(null),
    time: new UntypedFormControl({ value: '00:00', disabled: true }),
    applyRules: new UntypedFormControl(null),
    revetmentSurplus: new UntypedFormControl(0.0, { nonNullable: true }),
    visit: new UntypedFormControl(''),
    relatedTaskId: new UntypedFormControl(null),
    isPromotional: new UntypedFormControl(false),
    discountApplied: new UntypedFormControl(0),
  });

  ngOnInit(): void {
    this.getProductQualityList();
    this.getTaskGroups();

    const dateCtrl = this.workTaskForm.controls.date;
    const timeCtrl = this.workTaskForm.controls.time;

    const dateSub = dateCtrl.valueChanges.subscribe((val) => {
      this.setTime();
    });
    this.subs.add(dateSub);

    const timeSub = timeCtrl.valueChanges.subscribe((val) => {
      this.timeSelected = true;
    });
    this.subs.add(timeSub);

    const merged = merge(dateCtrl.valueChanges, timeCtrl.valueChanges).pipe(
      debounceTime(120),
      map(() => {
        const d: Date | null = this.workTaskForm.controls.date.value;
        const day = d ? d.toISOString().split('T')[0] : null;
        const time = this.workTaskForm.controls.time.value || null;
        return { day, time };
      }),
      distinctUntilChanged((a, b) => a.day === b.day && a.time === b.time)
    ).subscribe(({ day, time }) => {
      if (!day) {
        this.clearSelectedContractor();
        this.supplierList = [];
        return;
      }

      this.clearSelectedContractor();
      this.getSuppliers();
    });
    this.subs.add(merged);

    const prodSub = this.workTaskForm.controls.product.valueChanges.subscribe((val: any) => {
      if (this.showProductProps) {
        let prod = this.products.find((x) => x.id == val);
        if (prod) this.colorList = prod.productColors;
      }
    });
    this.subs.add(prodSub);

    const applyRulesOn$ = this.workTaskForm.controls.applyRules.valueChanges
      .pipe(filter((val: boolean) => val))
      .subscribe(() => this.applyRule());
    this.subs.add(applyRulesOn$);

    const applyRulesOff$ = this.workTaskForm.controls.applyRules.valueChanges
      .pipe(filter((val: boolean) => !val))
      .subscribe(() => this.removeRule());
    this.subs.add(applyRulesOff$);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.coordinates && !changes.coordinates.firstChange) {
      this.getSuppliers();
    }
  }

  ngOnDestroy(): void {
    if (this.subs) {
      this.subs.unsubscribe();
    }
  }

  applyRule() {
    if (this.hasWorkTaskRules) {
      let rule = workTaskRules.find(
        (x) =>
          x.taskId == this.selectedTaskGroup?.id.toString() &&
          x.jobId == this.selectedJob?.id.toString()
      );
      rule?.defaultJobs.forEach((t) => {
        if (this.mayHaveSurplus(t.jobId)) {
          this.showRevetmentPropsByDefault = true;
        }
      });
    }
  }

  removeRule() {
    this.showRevetmentPropsByDefault = false;
  }

  disableButton() {
    this.disableSubmit.emit();
  }

  getSuppliers() {
    if (this.selectedTaskGroup != undefined && this.selectedJob != undefined) {
      let filter: ContractorSearchModel = {
        categoryId: this.selectedTaskGroup.id.toString(),
        subCategoryId: this.selectedJob.id.toString(),
        latitude: this.coordinates.latitude,
        longitude: this.coordinates.longitude,
      };

      // Availability is checked only once a time is chosen: with the default 00:00 every contractor looked busy
      // (the list went from 18 to 0 as soon as a date was picked).
      if (this.workTaskForm.controls.date.value && this.timeSelected) {
        filter.schudeledDate = this.datepipe.transform(this.getFullDateFromControls(), 'yyyy-MM-ddTHH:mm:ss' + this.getOffSet());
      }

      this.supplierSvc.search(filter).subscribe(
        (res: any[]) => {
          this.supplierList = res;
        },
        (err) => {
          console.error(err.message);
        }
      );
    }
  }

  selectContractor(event: any, el: SupplierModel) {
    if (this.selectedContractor === el.id.toString()) {
      this.selectedContractor = undefined;
      this.workTaskForm.controls['contractor'].setValue(null);
    } else {
      this.selectedContractor = el.id.toString();
      this.workTaskForm.controls['contractor'].setValue(el.id.toString());
    }
  }

  private clearSelectedContractor() {
    this.selectedContractor = undefined;
    this.workTaskForm.controls['contractor'].setValue(null, { emitEvent: false });
  }

  getTaskGroups() {
    if (this.fromCMR) {
      this.workTaskSvc.getTaskGroups().subscribe((data: TaskGruopModel[]) => {
        const siteVisitJob = findSiteVisitGroup(data);
        if (!siteVisitJob) {
          this.toastr.error('Tarea', 'No se encontró el tipo de tarea "Visita" para gestionar la oportunidad.');
          return;
        }
        this.taskGroups.push(siteVisitJob);
        this.getJobs(siteVisitJob);
      });
    } else {
      this.workTaskSvc
        .getVisibleTaskGroups()
        .subscribe((data: TaskGruopModel[]) => {
          this.taskGroups = data;
        });
    }
  }

  getJobs(group: TaskGruopModel) {
    this.hasWorkTaskRules = false;
    this.workTaskForm.controls.applyRules.setValue(this.hasWorkTaskRules);

    this.supplierList = [];
    this.workTaskForm.controls['taskGroup'].setValue(group.id);
    this.selectedTaskGroup = group;
    this.selectedJob = undefined;
    this.jobMissing = false;

    if (this.fromCMR) {
      this.workTaskSvc.getJobs(group.id).subscribe((data: JobModel[]) => {
        this.jobs = data;
        this.applyCmrRule(group);
      });
    } else {
      this.workTaskSvc
        .getVisibleJobs(group.id)
        .subscribe((data: JobModel[]) => {
          this.jobs = data;
        });
    }
    this.showVisits = this.mayHaveVisit();
    if (this.showVisits) {
      this.getVisits();
    }
    this.getSuppliers();
  }

  validateOnlyPositiveNumbers(event: KeyboardEvent) {
    let key = event.key;
    if (['.', 'e', 'E', ',', '-', '+'].includes(key)) {
      event.preventDefault();
    }

    if (this.promDiscount >= 99) {
      this.promDiscount = 99;
      this.form.controls.discountApplied.patchValue(99);
    }

    if (this.promDiscount <= 0) {
      this.promDiscount = 0;
      this.form.controls.discountApplied.patchValue(0);
    }
  }

  applyCmrRule(group: TaskGruopModel) {
    let rule = workTaskRules.find((x) => x.taskId == group.id.toString());
    if (rule) {
      if (rule.selectJob) {
        let job = this.jobs.find((x) => x.id.toString() == rule?.jobId);
        if (job) {
          this.selectJob(job);
        }
      }
    }
  }

  selectJob(job: JobModel) {
    this.selectedJob = job;
    this.jobMissing = false;
    this.selectedJobId = job.id.toString();
    this.showProductProps = [
      '1af64f64-5717-4562-b3fc-2c963f66afa1',
      '1af64f64-5717-4562-b3fc-2c963f66aba1',
      '1af64f64-5717-4562-b3fc-2c963f66bfa1',
      '1af64f64-5717-4562-b3fc-2c963f66aff1',
    ].includes(this.selectedJob?.id.toString());
    this.workTaskForm.controls.product.patchValue(null);
    this.workTaskForm.controls.productColor.patchValue(null);
    this.workTaskForm.controls.productQuality.patchValue(null);

    this.showRevetmentProps = this.mayHaveSurplus(
      this.selectedJob?.id.toString()
    );

    this.workTaskForm.controls['task'].setValue(job.id);
    this.getProducts(this.selectedJob.id);

    if (this.selectedTaskGroup && this.selectedJob) {
      this.hasWorkTaskRules =
        workTaskRules.filter(
          (x) =>
            x.taskId == this.selectedTaskGroup?.id.toString() &&
            x.jobId == job.id.toString() &&
            x.defaultJobs.length > 0
        ).length > 0;
      this.workTaskForm.controls.applyRules.setValue(this.hasWorkTaskRules);

      this.setValidatorsColorQuality();
      this.getSuppliers();
    }
  }

  setValidatorsColorQuality() {
    if (
      this.selectedTaskGroup?.description == 'Instalar' &&
      (this.selectedJob?.description == 'Piscina' ||
        this.selectedJob?.description == 'Piscina y Equipamiento')
    ) {
      this.workTaskForm.controls['productColor'].setValidators(
        Validators.required
      );
      this.workTaskForm.controls['productQuality'].setValidators(
        Validators.required
      );
    } else {
      this.workTaskForm.controls['productColor'].setValidators(null);
      this.workTaskForm.controls['productColor'].updateValueAndValidity();
      this.workTaskForm.controls['productQuality'].setValidators(null);
      this.workTaskForm.controls['productQuality'].updateValueAndValidity();
    }
  }

  // Validar si el prestador esta ocupado en el horario
  validateSupplierAvailability() {
    const fechaCompleta = this.datepipe.transform(this.getFullDateFromControls(), 'yyyy-MM-ddTHH:mm:ss' + this.getOffSet());
    if (fechaCompleta) {
      return this.workTaskSvc
        .getAvailableContractor(
          this.selectedContractor,
          fechaCompleta,
          this.selectedTaskGroup?.id
        )
        .pipe(
          map((response: boolean) => response === true),
          catchError((err) => {
            this.toastr.error('Error', err.error.error);
            return of(false);
          })
        );
    }
    return of(false);
  }

  getFullDateFromControls() {
    let date = this.workTaskForm.controls['date'].value;
    if (!date)
      return null;

    let time = this.workTaskForm.controls['time'].value?.split(':');
    if (time && this.timeSelected) {
      date.setHours(Number.parseInt(time[0]), Number.parseInt(time[1]), 0);
    }

    return date;
  }

  clearVisit() {
    this.workTaskForm.controls['visit'].setValue('');
  }

  async addWorkTask() {

    try {

      if (this.selectedJob != undefined && this.workTaskForm.valid) {

        let workForm = this.workTaskForm.value;

        const isSupplierAvailable = await this.handleSupplierAvailability();
        if (!isSupplierAvailable) {
          return;
        }

        if (workForm.visit) {
          workForm.relatedTaskId = workForm.visit.taskId;
        }

        workForm.taskDescription = this.selectedJob?.description;
        workForm.taskGroupDescription = this.selectedTaskGroup?.description;

        let workTask = workForm as WorkTaskModel;
        workTask.revetmentSurplus = workTask.revetmentSurplus ?? 0;
        workTask.isTimeSelected = this.timeSelected.valueOf();
        workTask.date = this.getFullDateFromControls();
        workTask.productName = this.products.find(x => x.id.toString() == workTask.product)?.name ?? "";

        if (this.selectedContractor) {
          workTask.contractorName = this.supplierList.find(x => x.id == Guid.parse(this.selectedContractor!))?.fullName ?? "";
        }

        this.jobsList.push(workTask);

        //Tareas relacionadas
        if (workForm.applyRules) {
          workTaskRules.forEach((rule) => {
            if (
              workForm.taskGroup == rule.taskId &&
              workForm.task == rule.jobId
            ) {
              rule.defaultJobs.forEach((d) => {
                let newTask = this.getDefaultWorktask(workTask, d);
                this.jobsList.push(newTask);
              });
            }
          });
        }

        this.cleanForm();
      } else {
        this.workTaskForm.markAllAsTouched();
        this.jobMissing = this.selectedJob == undefined;
        if (!this.selectedTaskGroup) {
          this.toastr.warning('Tarea', 'Elegí un tipo de tarea.');
        } else if (this.jobMissing) {
          this.toastr.warning('Tarea', 'Elegí una subcategoría.');
        } else {
          this.toastr.warning('Tarea', 'Completá los campos obligatorios marcados.');
        }
      }
    } catch (ex) {
      this.toastr.error(
        'Error',
        'Se produjo un error al intentar agregar tarea.'
      );
    }
  }

  getDefaultWorktask(currentTask: WorkTaskModel, taskData: any): WorkTaskModel {
    return {
      ...currentTask,
      task: taskData.jobId,
      taskDescription: taskData.jobName,
      taskGroup: taskData.taskId,
      taskGroupDescription: taskData.taskName,
      date: undefined,
      relatedTaskId: undefined,
      isTimeSelected: false,
      contractor: undefined,
      contractorName: '',
    };
  }

  private async handleSupplierAvailability(): Promise<boolean> {
    try {
      if (!this.selectedContractor || !this.workTaskForm.controls.date.value)
        return true;
      const result = await lastValueFrom(this.validateSupplierAvailability());
      return result;
    } catch {
      return false;
    }
  }

  cleanForm() {
    this.timeSelected = false;
    this.minHour = '00:00';
    this.supplierList = [];
    this.jobs = [];
    this.selectedJob = undefined;
    this.selectedJobId = '00000000-0000-0000-0000-000000000000';
    this.selectedTaskGroup = undefined;
    this.selectedContractor = undefined;
    this.client = this.form.controls['client'].value;
    this.hasWorkTaskRules = false;
    this.showProductProps = false;
    this.showRevetmentProps = false;
    this.showProimotionaldiscount = false;
    this.promDiscount = 0;
    this.showVisits = false;
    this.workTaskForm.controls['relatedTaskId'].setValue(null);
    this.workTaskForm.reset();
    this.workTaskForm.controls.time.disable();
    this.disableButton();
  }

  removeWorkTask(index: number) {
    this.jobsList.splice(index, 1);
  }

  getOffSet(): string {
    let offSet = new Date().getTimezoneOffset() / -60;
    let offSetFormated = Math.abs(offSet).toString().padStart(2, '0');
    return (offSet >= 0 ? '+' : '-') + offSetFormated + ':00';
  }

  getProducts(subCategoryId: Guid) {
    this.products = [];
    this.productSvc
      .getBySubCategory(subCategoryId)
      .subscribe((data: ProductModel[]) => {
        this.products = data;
      });
  }

  getVisits() {
    let cliente = this.form.controls['client'].value;
    this.workTaskSvc
      .getClientVisits(cliente.id)
      .subscribe((data: VisitModel[]) => {
        this.visitsList = data.filter((x) => x.consumed === false);
      });
  }

  getProductQualityList() {
    this.productSvc
      .getProductQualityList()
      .subscribe((data: ProductQualityModel[]) => {
        this.productsQualityList = data;
      });
  }

  onTimeChanged(event: any) {
    this.timeSelected = true;
  }

  setTime() {
    const selectedDate: Date | null = this.workTaskForm.controls.date.value;

    if (!selectedDate) {
      this.workTaskForm.controls.time.disable({ emitEvent: false });
      this.timeSelected = false;
      return;
    }

    const sel = new Date(selectedDate);
    sel.setHours(0, 0, 0, 0);
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const isToday = sel.getTime() === today.getTime();
    this.minHour = isToday
      ? this.datepipe.transform(new Date(), 'HH:mm') ?? '00:00'
      : '00:00';

    this.workTaskForm.controls.time.enable({ emitEvent: false });

    this.workTaskForm.controls['time'].setValue(this.minHour, { emitEvent: false });
    this.timeSelected = false;
  }

  mayHaveSurplus(jobId: string) {
    return [
      '1af64f64-5717-4562-b3fc-2c963f66afb1',
      '1af64f64-5717-4562-b3fc-2c963f66abb1',
      '1af64f64-5717-4562-b3fc-2c963f66bfb1',
    ].includes(jobId);
  }

  mayHaveVisit() {
    return this.selectedTaskGroup?.description == 'Instalar';
  }

  delay(ms: number) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }
}
